export default {
  'navigation.link.posts': 'Direct Posts',
  'navigation.link.watchlist': 'Watchlist',
  'navigation.link.info': 'Token Info',
  'navigation.authentication.login': 'Log In',
  'navigation.authentication.logout': 'Log Out',
};
